/*!
 * gift-promo.js
 * Auto-add/remove OMAGGIO product when cart subtotal (excluding gift) crosses €69.
 * Pairs with Shopify automatic BXGY discount that gives the OMAGGIO 100% off.
 * Integrates with window.sxCart and silences sxUpsell during silent gift add.
 * Also re-computes free shipping progress bar excluding the gift item.
 */
(function () {
  'use strict';

  // -----------------------------------------------
  // CONFIG
  // -----------------------------------------------
  var GIFT_VARIANT_ID = 57520046080335;
  var GIFT_PRODUCT_ID = 16062009901391;
  var THRESHOLD_CENTS = 6900;  // €69.00
  var BADGE_TEXT = '🎁 GRATIS!';
  var GIFT_HANDLE = 'omaggio';
  var GIFT_TITLE_UPPER = 'OMAGGIO';
  var DEBUG = false; // set to true to re-enable [gift-promo] console logs

  // -----------------------------------------------
  // STATE
  // -----------------------------------------------
  var isProcessing = false;
  var silentMode = false;
  var openDrawerPatched = false;
  var upsellPatched = false;

  // -----------------------------------------------
  // PATCHES (silenziano UI quando facciamo add/remove del gift)
  // -----------------------------------------------
  function patchOpenDrawerSilent() {
    if (openDrawerPatched) return;
    if (!window.sxCart || typeof window.sxCart.openDrawer !== 'function') return;
    openDrawerPatched = true;
    var orig = window.sxCart.openDrawer;
    window.sxCart.openDrawer = function () {
      if (silentMode) return;
      return orig.apply(this, arguments);
    };
  }

  // NOTE: we deliberately do NOT patch window.sxUpsell.open because that
  // would also block upsell setTimeouts scheduled by the theme for the
  // user's normal add-to-cart (which fired BEFORE our silentMode is set).
  // Instead we rely on the existing `window._sxUpsellSkip` flag check
  // the theme performs at response-handler time.

  function applyAllPatches() {
    patchOpenDrawerSilent();
  }

  // -----------------------------------------------
  // CART HELPERS
  // -----------------------------------------------
  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function nonGiftSubtotalCents(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id !== GIFT_VARIANT_ID) total += it.final_line_price;
    }
    return total;
  }

  function findGift(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFT_VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  // -----------------------------------------------
  // FREE SHIPPING PROGRESS BAR (exclude gift)
  // -----------------------------------------------
  function updateProgressBars(nonGiftCents) {
    var bars = document.querySelectorAll('free-ship-progress-bar');
    bars.forEach(function (bar) {
      if (typeof bar.init === 'function') {
        try { bar.init(nonGiftCents); } catch (e) { /* silent */ }
      }
      bar.setAttribute('data-order', String(nonGiftCents));
    });
    updateGiftBar(nonGiftCents);
  }

  // -----------------------------------------------
  // GIFT PROGRESS BAR (snippets/sx-gift-bar.liquid) — aggiunta 16/08/2026
  // -----------------------------------------------
  // Lo stato iniziale della barra lo calcola Liquid a ogni render della sezione,
  // quindi è già corretto al primo frame. Questa funzione serve per i casi in
  // cui il carrello cambia senza che la sezione venga ri-renderizzata.
  // Usa lo STESSO nonGiftCents della barra spedizione: le due barre non devono
  // mai raccontare due subtotali diversi.
  function updateGiftBar(nonGiftCents) {
    try {
      var bars = document.querySelectorAll('sx-gift-bar');
      if (!bars.length) return;
      bars.forEach(function (bar) {
        var threshold = parseInt(bar.getAttribute('data-gift-threshold'), 10) || THRESHOLD_CENTS;
        var reached = nonGiftCents >= threshold;
        var pct = Math.min(100, Math.round((nonGiftCents / threshold) * 100));

        bar.setAttribute('data-gift-subtotal', String(nonGiftCents));
        bar.classList.toggle('sx-gift-reached', reached);

        var fill = bar.querySelector('.sx-gift-fill');
        if (fill) fill.style.width = pct + '%';

        var msg = bar.querySelector('.sx-gift-msg');
        if (!msg) return;
        if (reached) {
          msg.innerHTML = '\uD83C\uDF81 <span class="congratulations">Congratulazioni!</span> ' +
                          'Il tuo omaggio da 20 \u20AC \u00E8 nel carrello';
        } else {
          // Formato importi del negozio: simbolo PRIMA, virgola decimale
          // (moneyFormat = "\u20AC{{amount_with_comma_separator}}"). Deve
          // combaciare con il filtro | money del render Liquid, altrimenti la
          // cifra cambia forma fra il primo frame e l'aggiornamento dal vivo.
          var missing = (threshold - nonGiftCents) / 100;
          msg.innerHTML = 'Ti mancano soltanto <span class="price">\u20AC' +
                          missing.toFixed(2).replace('.', ',') + '</span> ' +
                          'per ricevere il tuo <span class="subheading_weight primary-color">omaggio da 20 \u20AC</span>';
        }
      });
    } catch (e) { /* silent: la barra non deve mai rompere il carrello */ }
  }

  // -----------------------------------------------
  // SILENT ADD / REMOVE (con flag e patch attivi)
  // -----------------------------------------------
  function silentAdd() {
    applyAllPatches();
    silentMode = true;
    window._sxUpsellSkip = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
        sections: 'minicart-form',
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (data) {
      if (document.getElementById('main-cart-items')) refreshMainCart();
      return data;
    }).finally(function () {
      setTimeout(function () {
        silentMode = false;
        window._sxUpsellSkip = false;
      }, 1000);
    });
  }

  function silentRemove(itemKey) {
    applyAllPatches();
    silentMode = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0,
        sections: 'minicart-form',
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (data) {
      if (data && data.sections && data.sections['minicart-form'] && window.sxCart && window.sxCart.refreshMinicart) {
        window.sxCart.refreshMinicart(data.sections['minicart-form']);
      }
      if (document.getElementById('main-cart-items')) refreshMainCart();
      if (window.sxCart && window.sxCart.fetchAndUpdate) window.sxCart.fetchAndUpdate();
      return data;
    }).finally(function () {
      setTimeout(function () { silentMode = false; }, 1000);
    });
  }

  function refreshMainCart() {
    return fetch('/?sections=main-cart-items', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['main-cart-items']) return;
        var html = new DOMParser().parseFromString(data['main-cart-items'], 'text/html');
        var newContent = html.querySelector('#main-cart-items');
        var target = document.getElementById('main-cart-items');
        if (newContent && target) target.innerHTML = newContent.innerHTML;
      })
      .catch(function () { /* silent */ });
  }

  // -----------------------------------------------
  // BADGE STYLING + LOCK CONTROLS
  // -----------------------------------------------
  var LINE_ITEM_SELECTORS = 'tr.cart-item, .cart-item, li.minicart__item, [id^="minicart__product-"]';

  function findGiftLineItemsDOM() {
    var giftItems = new Set();
    // S0: by custom attribute product-handle (drawer wrapper has product-handle="omaggio")
    document.querySelectorAll('[product-handle="' + GIFT_HANDLE + '"]').forEach(function (el) {
      // The el ITSELF is the wrapper in drawer
      giftItems.add(el);
      // Or its closest if nested
      var li = el.closest(LINE_ITEM_SELECTORS);
      if (li && li !== el) giftItems.add(li);
    });
    // S1: by href
    document.querySelectorAll('a[href*="/products/' + GIFT_HANDLE + '"]').forEach(function (link) {
      var li = link.closest(LINE_ITEM_SELECTORS);
      if (li) giftItems.add(li);
    });
    // S2: by data-product-id (drawer uses item.product.id = product id)
    document.querySelectorAll('[data-product-id="' + GIFT_PRODUCT_ID + '"], [data-product-id="' + GIFT_VARIANT_ID + '"], [data-variant-id="' + GIFT_VARIANT_ID + '"]').forEach(function (el) {
      var li = el.closest(LINE_ITEM_SELECTORS);
      if (li) giftItems.add(li);
    });
    // S3: by title "OMAGGIO" exact match in product name link
    document.querySelectorAll('h3.minicart__product-name a, h3 a, td.cart-item__details a, .cart-item__name a, a.cart-item__link, a.no-underline').forEach(function (link) {
      var txt = (link.textContent || '').trim().toUpperCase();
      if (txt === GIFT_TITLE_UPPER) {
        var li = link.closest(LINE_ITEM_SELECTORS);
        if (li) giftItems.add(li);
      }
    });
    return Array.from(giftItems);
  }

  function findGiftLineItemsByKey(key) {
    var giftItems = new Set();
    // Drawer: id="minicart__product-{key}"
    var d = document.getElementById('minicart__product-' + key);
    if (d) giftItems.add(d);
    // Main cart: input[id="{key}"]
    var keyEl = document.getElementById(key);
    if (keyEl) {
      var li = keyEl.closest(LINE_ITEM_SELECTORS);
      if (li) giftItems.add(li);
    }
    document.querySelectorAll('[data-id="' + key + '"], [data-key="' + key + '"]').forEach(function (el) {
      var li = el.closest(LINE_ITEM_SELECTORS);
      if (li) giftItems.add(li);
    });
    return Array.from(giftItems);
  }

  var HIDE_SELECTORS = [
    'mini-cart-remove-button', 'cart-remove-button', '.cart-remove',
    '.remove-icon', 'svg.remove-icon',
    'quantity-input', '.quantity', '.cart-item__quantity', '.cart-item__quantity-wrapper',
    'input[name="updates"]', 'input[name="updates[]"]',
    'button[name="minus"]', 'button[name="plus"]', '.quantity__button'
  ];

  function hideControls(item) {
    HIDE_SELECTORS.forEach(function (sel) {
      item.querySelectorAll(sel).forEach(function (el) {
        // Inline style with !important: beats any CSS specificity / cache issues.
        el.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function decorateGiftLineItem(item) {
    item.classList.add('cart-gift-item');

    var priceContainer = item.querySelector(
      '.cart-item__price-wrapper, .cart-item__final-price, .cart-item__price, ' +
      '.minicart__item-prices, .minicart__item-price, .minicart__discounted-prices'
    );
    if (priceContainer && !priceContainer.querySelector('.gift-badge')) {
      var badge = document.createElement('span');
      badge.className = 'gift-badge';
      badge.textContent = BADGE_TEXT;
      // Inline styles (sx-cart-overrides.css is not loaded by the theme)
      badge.style.cssText =
        'display:inline-block;margin-left:8px;padding:3px 8px;' +
        'background:linear-gradient(135deg,#ff6b6b,#ee5253);' +
        'color:#fff;border-radius:4px;font-size:11px;font-weight:700;' +
        'letter-spacing:0.5px;text-transform:uppercase;' +
        'vertical-align:middle;line-height:1.4;';
      priceContainer.appendChild(badge);
    }

    // Force-hide controls (defense in depth — independent of CSS cache).
    hideControls(item);

    item.dataset.giftBadged = 'yes';
    if (DEBUG) console.log('[gift-promo] decorated item:', item);
  }

  function applyGiftBadges() {
    // Sync: try DOM-only
    var domItems = findGiftLineItemsDOM();
    if (DEBUG) console.log('[gift-promo] applyGiftBadges DOM matches:', domItems.length);
    domItems.forEach(decorateGiftLineItem);

    // Async fallback by cart key — handles edge cases (missing href, custom rendering)
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === GIFT_VARIANT_ID) { giftItem = cart.items[i]; break; }
        }
        if (DEBUG) console.log('[gift-promo] cart gift item:', giftItem);
        if (!giftItem) return;
        var keyItems = findGiftLineItemsByKey(giftItem.key);
        if (DEBUG) console.log('[gift-promo] by-key matches:', keyItems.length);
        keyItems.forEach(decorateGiftLineItem);
      })
      .catch(function () { /* silent */ });
  }

  // -----------------------------------------------
  // MAIN CHECK
  // -----------------------------------------------
  function checkGift() {
    if (isProcessing) return Promise.resolve();
    isProcessing = true;
    return getCart()
      .then(function (cart) {
        var nonGiftCents = nonGiftSubtotalCents(cart);
        var gift = findGift(cart);

        // Always update progress bars with non-gift subtotal
        updateProgressBars(nonGiftCents);

        if (nonGiftCents >= THRESHOLD_CENTS && !gift) {
          return silentAdd().then(function () { return getCart(); }).then(function (c2) {
            updateProgressBars(nonGiftSubtotalCents(c2));
          });
        } else if (nonGiftCents < THRESHOLD_CENTS && gift) {
          return silentRemove(gift.key).then(function () { return getCart(); }).then(function (c2) {
            updateProgressBars(nonGiftSubtotalCents(c2));
          });
        } else if (gift && gift.quantity > 1) {
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 1, sections: 'minicart-form', sections_url: window.location.pathname })
          });
        }
      })
      .catch(function (e) { console.error('[gift-promo]', e); })
      .finally(function () {
        setTimeout(function () { isProcessing = false; }, 600);
        setTimeout(applyGiftBadges, 700);
      });
  }

  // -----------------------------------------------
  // INIT
  // -----------------------------------------------
  function init() {
    applyAllPatches();
    applyGiftBadges();

    var minicartEl = document.getElementById('minicart-form');
    if (minicartEl) {
      new MutationObserver(function () { applyGiftBadges(); applyAllPatches(); })
        .observe(minicartEl, { childList: true, subtree: true });
    }
    var mainCartEl = document.getElementById('main-cart-items');
    if (mainCartEl) {
      new MutationObserver(function () { applyGiftBadges(); })
        .observe(mainCartEl, { childList: true, subtree: true });
    }

    document.addEventListener('cart:updated', function () {
      setTimeout(checkGift, 150);
    });

    // The theme dispatches cart:updated only for /cart/add. For /cart/change
    // (remove / quantity change), we need our own hook. Wrap window.fetch
    // (chains with the theme's existing wrapper) and trigger checkGift after
    // any cart-modifying request.
    var _origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';
      var promise = _origFetch.apply(this, arguments);
      if (!silentMode && /\/cart\/(change|update|clear)/.test(url)) {
        promise.then(function () {
          setTimeout(checkGift, 300);
        }).catch(function () {});
      }
      return promise;
    };

    // Initial check (after DOM ready + sxUpsell defined)
    setTimeout(function () { applyAllPatches(); checkGift(); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
